import dayjs from 'dayjs';

import { getStartEndTimeOfMultDays, useAuthContext, useSyncExerciseDetails } from '../data-access';

interface SyncExerciseDataParams {
  terraUserIds: string[];
  startDate: string;
  endDate: string;
}

export const useSyncExerciseData = () => {
  const { syncExerciseDetail } = useSyncExerciseDetails();
  const { user } = useAuthContext();

  const syncExerciseData = async ({ terraUserIds, startDate, endDate }: SyncExerciseDataParams) => {
    if (!user.metricId || !user.userId || !terraUserIds.length) {
      return;
    }

    const { startTime, endTime } = getStartEndTimeOfMultDays(dayjs(startDate), dayjs(endDate));

    if (terraUserIds.length) {
      try {
        await syncExerciseDetail({
          metricId: user.metricId,
          terraUserIds,
          startDate: startTime.toISOString(),
          endDate: endTime.toISOString(),
        });
      } catch (error) {
        console.error('Error syncing exercise data', error);
      }
    }
  };

  return { syncExerciseData };
};
